import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider,
    MenuItem, Grid, InputLabel, TextField, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik, Form } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import DeleteIcon from '@material-ui/icons/Delete';
import { AlertDialogWithoutButton } from 'src/views/Common/AlertDialogWithoutButton';
import EditIcon from '@material-ui/icons/Edit';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    table: {
        minWidth: 550,
    },

    green: {
        backgroundColor: 'green'
    },

    red: {
        backgroundColor: 'red'
    }
}));

const screenCode = "DIRECTPURCHASEORDER"

export default function DirectPurchaseOrderAddEdit() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    let decryptedID = 0;
    let decryptedStatusID = 0;
    const { directPurchaseOrderID, statusID } = useParams();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [dialogbox, setDialogbox] = useState(false);
    const [dialogboxOne, setDialogboxOne] = useState(false);
    const [dialogboxTwo, setDialogboxTwo] = useState(false);
    const [decryptedIDD, setDecryptedID] = useState();
    const [decryptedStatusIDD, setDecryptedStatusID] = useState(0);
    const [SKUCategoryNames, setSKUCategoryNames] = useState();
    const [item, setItem] = useState([]);
    const [itemCopy, setItemCopy] = useState([]);
    const [budgetCodes, setBudgetCodes] = useState([]);
    const [date, setDate] = useState(new Date());
    const [isUpdate, setIsUpdate] = useState(false);
    const [isUpdate2, setIsUpdate2] = useState(false);
    const [gridDatArray, setGridDatArray] = useState([]);
    const [dpoNumber, setDpoNumber] = useState('');
    const [measuringUnitName, setMeasuringUnitName] = useState('');
    const [supplierCommon, setSupplierCommon] = useState(false);
    const [suppliersAuto, setSuppliersAuto] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [availableQuantity, setAvailableQuantity] = useState('');
    const [directPurchaseOrderDetails, setDirectPurchaseOrderDetails] = useState({
        groupID: '0',
        factoryID: '0',
        dpoTypeID: '0',
        supplierID: '0',
        supplierName: '',
        supplierContactNo: '',
        skuCategoryID: '0',
        itemName: '0',
        requestAmount: '',
        department: '0',
        warehouseID: '0',
        budgetCodeID: '0',
        unitPrice: '',
        remark: '',
        discount: '0',
        directPurchaseOrderDetailsID: '0',
        isUrgent: false,
    });
    const [vatRate, setVatRate] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermissions(), getBudgetCodeDetails()
        );
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropdown());
    }, [directPurchaseOrderDetails.groupID]);

    useEffect(() => {
        trackPromise(
            getItemByItemCategoryForDropDown()
        );
    }, [directPurchaseOrderDetails.budgetCodeID, directPurchaseOrderDetails.skuCategoryID])

    // useEffect(() => {
    //     if (directPurchaseOrderDetails.budgetCodeID > 0 || isUpdate) {
    //         trackPromise(getSKUCategoryNamesForDropdown());
    //     };
    // }, [directPurchaseOrderDetails.budgetCodeID]);

    useEffect(() => {
        decryptedID = atob(directPurchaseOrderID.toString());
        decryptedStatusID = atob(statusID.toString());
        if (decryptedID != 0) {
            trackPromise(GetDirectPurchaseOrderDetailsByDPOrderID(decryptedID));
            setDecryptedID(decryptedID)
        }
        setDecryptedStatusID(decryptedStatusID)
    }, []);

    useEffect(() => {
        if (parseInt(directPurchaseOrderDetails.itemName) != 0) {
            trackPromise(
                getAvailableQuantity()
            );
        }
    }, [directPurchaseOrderDetails.itemName])


    useEffect(() => {
        if (directPurchaseOrderDetails.budgetCodeID == 0) {
            setSKUCategoryNames()
        }
    }, [directPurchaseOrderDetails.budgetCodeID])

    useEffect(() => {
        if (directPurchaseOrderDetails.budgetCodeID > 0 && directPurchaseOrderDetails.factoryID > 0) {
            trackPromise(getSKUCategoryNamesForDropdown());
        };
    }, [directPurchaseOrderDetails.budgetCodeID, directPurchaseOrderDetails.factoryID]);


    useEffect(() => {
        if (!isUpdate) {
            setDirectPurchaseOrderDetails({
                ...directPurchaseOrderDetails,
                factoryID: '0',
                skuCategoryID: '0',
                itemName: '0',
                requestAmount: '',
                warehouseID: '0',
                budgetCodeID: '0',
                isUrgent: false,
            })
            setGridDatArray([]);
            setDate(new Date());
            setDpoNumber('');
        }
    }, [directPurchaseOrderDetails.groupID])

    useEffect(() => {
        trackPromise(getSuppliersForDropDownAuto(), getSuppliersForDropDown())
        if (!isUpdate) {
            setDirectPurchaseOrderDetails({
                ...directPurchaseOrderDetails,
                skuCategoryID: '0',
                itemName: '0',
                requestAmount: '',
                warehouseID: '0',
                budgetCodeID: '0',
                isUrgent: false,
            })
            setGridDatArray([]);
            setDate(new Date());
            setDpoNumber('');
        }
    }, [directPurchaseOrderDetails.factoryID])

    useEffect(() => {
        if (!isUpdate) {
            setDirectPurchaseOrderDetails({
                ...directPurchaseOrderDetails,
                skuCategoryID: '0',
                itemName: '0',
                requestAmount: '',
                budgetCodeID: '0',
                isUrgent: false,
            })
            setGridDatArray([]);
            setDate(new Date());
        }
    }, [directPurchaseOrderDetails.warehouseID])

    useEffect(() => {
        if (!isUpdate) {
            setDirectPurchaseOrderDetails({
                ...directPurchaseOrderDetails,
                skuCategoryID: '0',
                itemName: '0',
                requestAmount: '',
                isUrgent: false,
            })
        }
    }, [directPurchaseOrderDetails.budgetCodeID])

    useEffect(() => {
        if (!isUpdate && !isUpdate2) {
            setDirectPurchaseOrderDetails({
                ...directPurchaseOrderDetails,
                itemName: '0',
                requestAmount: '',
            })
        }
    }, [directPurchaseOrderDetails.skuCategoryID])

    useEffect(() => {
        const found = itemCopy?.find(x => x.skuMasterID == parseInt(directPurchaseOrderDetails.itemName))?.measuringUnitName
        setMeasuringUnitName(found ?? '')
        if (!isUpdate && !isUpdate2) {
            setDirectPurchaseOrderDetails({
                ...directPurchaseOrderDetails,
                requestAmount: '',
            })
        }
    }, [directPurchaseOrderDetails.itemName])

    useEffect(() => {
        decryptedID = atob(directPurchaseOrderID.toString());
        decryptedStatusID = atob(statusID.toString());
        if (decryptedID != 0) {
            setDecryptedID(decryptedID)
        }
        setDecryptedStatusID(decryptedStatusID)
    }, [directPurchaseOrderID]);

    useEffect(() => {
        if (directPurchaseOrderDetails.supplierID > 0) {
            trackPromise(getSupplierVatDetails(directPurchaseOrderDetails.supplierID));
        }
    }, [directPurchaseOrderDetails.supplierID]);

    const handleClick = () => {
        navigate('/app/directPurchaseOrder/listing');
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITDIRECTPURCHASEORDER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setDirectPurchaseOrderDetails({
            ...directPurchaseOrderDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropdown() {
        const factories = await services.getAllFactoriesByGroupID(directPurchaseOrderDetails.groupID);
        setFactories(factories);
    }
    async function getBudgetCodeDetails() {
        var response = await services.getBudgetCodeDetails();
        setBudgetCodes(response);
    }

    async function getSuppliersForDropDown() {
        const supplierResult = await services.getSuppliersForDropDown(
            directPurchaseOrderDetails.factoryID
        );
        setSuppliers(supplierResult);
    }

    async function getSuppliersForDropDownAuto() {
        const supplierResult = await services.getSuppliersForDropDownAuto(
            directPurchaseOrderDetails.factoryID
        );
        setSuppliersAuto(supplierResult);
    }

    // async function getSKUCategoryNamesForDropdown() {
    //     const SKUCategoryNames = await services.GetSKUCategoryNamesByID(directPurchaseOrderDetails.budgetCodeID, directPurchaseOrderDetails.groupID, directPurchaseOrderDetails.supplierID);
    //     setSKUCategoryNames(SKUCategoryNames);
    // }
    async function getSKUCategoryNamesForDropdown() {
        const SKUCategoryNames = await services.GetSKUCategoryNamesByID(directPurchaseOrderDetails.budgetCodeID, directPurchaseOrderDetails.groupID, directPurchaseOrderDetails.factoryID);
        setSKUCategoryNames(SKUCategoryNames);
    }

    async function getItemByItemCategoryForDropDown() {
        var res = await services.getItemByItemCategoryForDropDown(directPurchaseOrderDetails.skuCategoryID , directPurchaseOrderDetails.supplierID);
        let skuItemArray = []
        for (let item of Object.entries(res)) {
            skuItemArray[item[1]["skuMasterID"]] = item[1]["skuMasterName"]
        }
        setItemCopy(res)
        setItem(skuItemArray);
    }

    async function getAvailableQuantity() {
        let response = await services.getAvailableQuantity(directPurchaseOrderDetails.groupID, directPurchaseOrderDetails.factoryID, directPurchaseOrderDetails.skuCategoryID, directPurchaseOrderDetails.itemName);
        if (response.statusCode === "Success") {
            setAvailableQuantity(response.data.availableQuantity);
        }
        else {
            setAvailableQuantity(0);
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function generateDropDownMenuWithTwoValues(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value.name}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value

        setDirectPurchaseOrderDetails({
            ...directPurchaseOrderDetails,
            [e.target.name]: value
        });
    }

    async function GetDirectPurchaseOrderDetailsByDPOrderID(directPurchaseOrderID) {
        let response = await services.GetDirectPurchaseOrderDetailsByDPOrderID(directPurchaseOrderID);
        if (response.length != 0) {
            setIsUpdate(true);
            setDirectPurchaseOrderDetails((prevState) => ({
                ...prevState,
                groupID: response[0].groupID,
                factoryID: response[0].factoryID,
                dpoTypeID: response[0].dpoTypeID,
                supplierID: response[0].supplierID,
                budgetCodeID: response[0].budgetCodeID,
                supplierName: response[0].supplierName,
                supplierContactNo: response[0].supplierContactNo
            }));
            setSupplierCommon(response[0].isGeneralSupplier)
            setDpoNumber(response[0].dpoNumber)
            setDate(new Date(response[0].purchaseDate))
            response[0].details.forEach(x => {
                x.total = x.totalAmount
                x.discount = x.discountAmount
                x.skuMesuringUnit = x.measuringUnitName
            });
            setGridDatArray(response[0].details)
        }
    }

    function handleClickEditTheRow(row, index) {
        setIsUpdate2(true)
        setDirectPurchaseOrderDetails((prevState) => ({
            ...prevState,
            skuCategoryID: row.skuCategoryID,
            itemName: row.skuMasterID,
            requestAmount: row.requestedQuantity,
            unitPrice: row.unitPrice,
            discount: row.discount,
            remark: row.remark,
            directPurchaseOrderDetailsID: isUpdate ? row.directPurchaseOrderDetailsID : 0
        }));
        const dataDelete = [...gridDatArray];
        const remove = index;
        dataDelete.splice(remove, 1);
        setGridDatArray([...dataDelete]);
        const found = itemCopy?.find(x => x.skuMasterID == parseInt(row.skuMasterID))?.measuringUnitName
        setMeasuringUnitName(found ?? '')
    }

    const [indexToDelete, setIndexToDelete] = useState(null);

    function DeleteItem(row, deleteIndex) {
        setIndexToDelete(deleteIndex);
        setDialogbox(true);
    }

    async function confirmData() {
        if (indexToDelete === null) return;

        const dataDelete = [...gridDatArray];
        dataDelete.splice(indexToDelete, 1);
        setGridDatArray(dataDelete);

        setDirectPurchaseOrderDetails((prevState) => ({
            ...prevState,
            itemName: '0',
            requestAmount: '',
            unitPrice: '',
            discount: '0',
            remark: '',
            directPurchaseOrderDetailsID: '0'
        }));

        setMeasuringUnitName('');

        setIsUpdate2(false);

        setIndexToDelete(null);

        setDialogbox(false);

        alert.success('SKU deleted successfully');
    }

    function handleApprove() {
        setDialogboxOne(true)
    }

    function handleReject() {
        setDialogboxTwo(true)
    }

    async function confirmDataOne() {
        let genaralModel = {
            directPurchaseOrderID: isUpdate ? parseInt(decryptedIDD) : 0,
            groupID: parseInt(directPurchaseOrderDetails.groupID),
            factoryID: parseInt(directPurchaseOrderDetails.factoryID),
            purchaseDate: moment(date.toString()).format('').split('T')[0],
            dpoTypeID: parseInt(directPurchaseOrderDetails.dpoTypeID),
            supplierID: parseInt(directPurchaseOrderDetails.supplierID),
            isGeneralSupplier: supplierCommon,
            supplierName: directPurchaseOrderDetails.supplierName,
            supplierContactNo: directPurchaseOrderDetails.supplierContactNo,
            budgetCodeID: parseInt(directPurchaseOrderDetails.budgetCodeID),
            headTotal: parseFloat(gridDatArray.reduce((accumulator, current) => accumulator + (current.requestedQuantity * current.unitPrice), 0)),
            discount: parseFloat(gridDatArray.reduce((accumulator, current) => accumulator + current.discount, 0)),
            netAmount: parseFloat(gridDatArray.reduce((accumulator, current) => accumulator + current.total, 0)),
            createdBy: tokenService.getUserIDFromToken(),
            statusID: 2, //Approve
            details: gridDatArray
        }
        var res = await services.DirectPurchaseOrderApproveReject(genaralModel.directPurchaseOrderID, genaralModel.createdBy, genaralModel.statusID);
        if (res.statusCode == "Success") {
            alert.success("Direct Purchase Order Approved Successfully");
            navigate('/app/directPurchaseOrder/listing');
        }
        else {
            alert.error("Error occured in approve Direct Purchase Order");
        }
        setDialogboxOne(false);
    }
    async function confirmDataTwo() {
        var res = await services.DirectPurchaseOrderReject(decryptedIDD, tokenService.getUserIDFromToken(), 3);
        if (res.statusCode == "Success") {
            alert.success("Direct Purchase Order Rejected Successfully");
            navigate('/app/directPurchaseOrder/listing');
        }
        else {
            alert.error("Error occured in reject Direct Purchase Order");
        }
        setDialogboxTwo(false);
    }

    function cancelData() {
        setIndexToDelete(null);
        setDialogbox(false);
    }

    function cancelDataOne() {
        setDialogboxOne(false);
    }

    function cancelDataTwo() {
        setDialogboxTwo(false);
    }

    async function addToGrid() {
        if (supplierCommon == true) {
            if (directPurchaseOrderDetails.budgetCodeID == '0' || directPurchaseOrderDetails.dpoTypeID == '0' || directPurchaseOrderDetails.supplierID == '0' || directPurchaseOrderDetails.supplierName == '') {
                alert.error('Please fill all required fields');
                return;
            }
        }
        else {
            if (directPurchaseOrderDetails.budgetCodeID == '0' || directPurchaseOrderDetails.dpoTypeID == '0' || directPurchaseOrderDetails.supplierID == '0') {
                alert.error('Please fill all required fields');
                return;
            }
        }
        const found = itemCopy?.find(x => x.skuMasterID == parseInt(directPurchaseOrderDetails.itemName))?.measuringUnitName
        const warehouseSKUMappingID = itemCopy?.find(x => x.skuMasterID == parseInt(directPurchaseOrderDetails.itemName))?.warehouseSKUMappingID
        const itemDetailsID = itemCopy?.find(x => x.skuMasterID == parseInt(directPurchaseOrderDetails.itemName))?.itemDetailsID
        const vatAmount = (parseFloat(directPurchaseOrderDetails.requestAmount) * parseFloat(directPurchaseOrderDetails.unitPrice)) * parseFloat(vatRate);
        const newModel = {
            directPurchaseOrderDetailsID: isUpdate ? parseInt(directPurchaseOrderDetails.directPurchaseOrderDetailsID) : 0,
            skuCategoryName: SKUCategoryNames[directPurchaseOrderDetails.skuCategoryID],
            skuCategoryID: parseInt(directPurchaseOrderDetails.skuCategoryID),
            skuMasterName: item[directPurchaseOrderDetails.itemName],
            skuMasterCode: item[directPurchaseOrderDetails.itemName],
            itemDetailsID: itemDetailsID,
            skuMasterID: parseInt(directPurchaseOrderDetails.itemName),
            skuMesuringUnit: found,
            warehouseSKUMappingID: warehouseSKUMappingID,
            requestedQuantity: parseFloat(directPurchaseOrderDetails.requestAmount),
            unitPrice: parseFloat(directPurchaseOrderDetails.unitPrice),
            total: parseFloat(directPurchaseOrderDetails.requestAmount) * parseFloat(directPurchaseOrderDetails.unitPrice) + vatAmount,
            remark: directPurchaseOrderDetails.remark,
            discount: parseFloat(directPurchaseOrderDetails.discount),
            vatAmount: vatAmount,
        };
        const isDuplicate = gridDatArray.some(
            (row) =>
                row.skuCategoryID === newModel.skuCategoryID &&
                row.skuMasterID === newModel.skuMasterID
        );

        if (isDuplicate) {
            alert.error('Cannot Add Duplicate SKU');
            return;
        }
        else {
            setGridDatArray([...gridDatArray, newModel]);
            if (isUpdate == true) {
                alert.success('Row Updated');
            }
        }
        setDirectPurchaseOrderDetails((prevState) => ({
            ...prevState,
            itemName: '0',
            requestAmount: '',
            unitPrice: '',
            remark: '',
        }));
        setIsUpdate2(false)
    }

    async function onSave() {
        let genaralModel = {
            directPurchaseOrderID: isUpdate ? parseInt(decryptedIDD) || 0 : 0,
            groupID: parseInt(directPurchaseOrderDetails.groupID) || 0,
            factoryID: parseInt(directPurchaseOrderDetails.factoryID) || 0,
            purchaseDate: moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : '',
            dpoTypeID: parseInt(directPurchaseOrderDetails.dpoTypeID) || 0,
            supplierID: parseInt(directPurchaseOrderDetails.supplierID) || 0,
            isGeneralSupplier: supplierCommon,
            supplierName: supplierCommon ? (directPurchaseOrderDetails.supplierName || '').trim() : '',
            supplierContactNo: supplierCommon ? (directPurchaseOrderDetails.supplierContactNo || '').trim() : '',
            budgetCodeID: parseInt(directPurchaseOrderDetails.budgetCodeID) || 0,
            headTotal: gridDatArray.length > 0 ? parseFloat(gridDatArray.reduce((accumulator, current) => accumulator + (current.requestedQuantity * current.unitPrice || 0), 0)) : 0,
            discount: gridDatArray.length > 0 ? parseFloat(gridDatArray.reduce((accumulator, current) => accumulator + (current.discount || 0), 0)) : 0,
            netAmount: gridDatArray.length > 0 ? parseFloat(gridDatArray.reduce((accumulator, current) => accumulator + (current.total || 0), 0)) : 0,
            vatAmount: gridDatArray.length > 0 ? parseFloat(gridDatArray.reduce((accumulator, current) => accumulator + (current.vatAmount || 0), 0)) : 0,
            createdBy: tokenService.getUserIDFromToken() || 0,
            details: gridDatArray.map(item => ({
                ...item,
                requestedQuantity: item.requestedQuantity || 0,
                unitPrice: item.unitPrice || 0,
                discount: item.discount || 0,
                vatAmount: item.vatAmount || 0,
                total: item.total || 0,
                skuCategoryName: item.skuCategoryName || "",
                skuMasterName: item.skuMasterName || "",
                skuMesuringUnit: item.skuMesuringUnit || "",
                warehouseSKUMappingID: item.warehouseSKUMappingID || "",
                itemDetailsID: item.itemDetailsID || "",
                remark: item.remark || ""
            }))
        };

        let generalModelList = [];
        generalModelList.push(genaralModel);

        if (!genaralModel.groupID || !genaralModel.factoryID || !genaralModel.purchaseDate || !genaralModel.dpoTypeID || !genaralModel.supplierID || !genaralModel.budgetCodeID) {
            alert.error('Please fill all required fields before submitting.');
            return;
        }

        setIsSubmitting(true);
        try {
            if (isUpdate) {
                var res = await services.UpdateDirectPurchaseOrder(genaralModel);
                if (res.statusCode == "Success") {
                    alert.success(res.message);
                    navigate('/app/directPurchaseOrder/listing');
                }
                else {
                    alert.error(res.message);
                    setIsSubmitting(false);
                }
            }
            else {
                var res = await services.SaveDirectPurchaseOrder(generalModelList);
                if (res.statusCode == "Success") {
                    alert.success(res.message);
                    navigate('/app/directPurchaseOrder/listing');
                }
                else {
                    alert.error(res.message);
                    setIsSubmitting(false);
                }
            }
        } catch (error) {
            alert.error('An error occurred while saving');
            setIsSubmitting(false);
        }
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                    />
                </Grid>
            </Grid>
        )
    }

    function handleSearchDropdownChangeFieldsSupplier(data, e) {
        if (data === undefined || data === null) {
            setDirectPurchaseOrderDetails({
                ...directPurchaseOrderDetails,
                supplierID: '0'
            });
            return;
        } else {
            var valueV = data["supplierID"];
            var valueC = data["supplierCode"];
            setDirectPurchaseOrderDetails({
                ...directPurchaseOrderDetails,
                supplierID: valueV
            });

            if ((parseInt(valueV) > 0) && (valueC == 'COMMON')) {
                setSupplierCommon(true);
            } else {
                setSupplierCommon(false);
            }
        }
    }

    function changeGeneralText(e, i) {
        const target = e.target;
        const value = target.value;
        const finalValue = value == "" ? parseFloat(0) : value
        var reg = new RegExp('^[0-9]{0,9}([.]?[0-9]{0,2})?$');
        const newArr = [...gridDatArray];
        if (reg.test(finalValue) == false) {
            alert.success("Allow Only Positive Numbers");
            return;
        }
        else if (parseFloat(newArr[i].requestedQuantity * newArr[i].unitPrice) <= parseFloat(finalValue)) {
            alert.error("Discount Can not be Greater Than Head Total");
            return;
        }
        newArr[i] = {
            ...newArr[i],
            ["discount"]: finalValue == "" ? parseFloat(0) : parseFloat(finalValue),
            ["total"]: finalValue == "" ? ((newArr[i].requestedQuantity * newArr[i].unitPrice) + newArr[i].vatAmount) - parseFloat(0) : ((newArr[i].requestedQuantity * newArr[i].unitPrice) + newArr[i].vatAmount) - parseFloat(finalValue),
        };
        setGridDatArray(newArr)
    }

    async function getSupplierVatDetails(supplierID) {
        var res = await services.GetSupplierVatDetails(supplierID);
        if (res.statusCode == "Success") {
            setVatRate(res.data.vatRate);
        }
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title={decryptedStatusIDD == 1 ? "Update Direct Purchase Order" : decryptedStatusIDD == 2 ? "View Direct Purchase Order" : "Approve Direct Purchase Order"}
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: directPurchaseOrderDetails.groupID,
                            factoryID: directPurchaseOrderDetails.factoryID,
                            dpoTypeID: directPurchaseOrderDetails.dpoTypeID,
                            supplierID: directPurchaseOrderDetails.supplierID,
                            supplierName: directPurchaseOrderDetails.supplierName,
                            budgetCodeID: directPurchaseOrderDetails.budgetCodeID,
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                dpoTypeID: Yup.number().required('DPO Type is required').min("1", 'DPO Type is required'),
                                supplierID: Yup.number().required('Supplier is required').min("1", 'Supplier is required'),
                                supplierName: supplierCommon == true ? Yup.string().required('Supplier Name is required') : Yup.string().notRequired(),
                                budgetCodeID: Yup.number().required('Account Code is required').min("1", 'Account Code is required'),
                            })
                        }
                        enableReinitialize
                        onSubmit={() => trackPromise(onSave())}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            props
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(decryptedStatusIDD == 1 ? "Add Direct Purchase Order" : decryptedStatusIDD == 2 ? "Update Direct Purchase Order" : decryptedStatusIDD == 3 ? "View Direct Purchase Order" : "Approve Direct Purchase Order")}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "1rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={directPurchaseOrderDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={!permissionList.isGroupFilterEnabled || isUpdate || gridDatArray.length > 0}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            fullWidth
                                                            name="factoryID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={directPurchaseOrderDetails.factoryID}
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={!permissionList.isFactoryFilterEnabled || isUpdate || gridDatArray.length > 0}

                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>
                                                            Purchase Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="date"
                                                                value={date}
                                                                onChange={(e) => {
                                                                    setDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                disabled={isUpdate || gridDatArray.length > 0}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="dpoTypeID">
                                                            DPO Type *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.dpoTypeID && errors.dpoTypeID)}
                                                            helperText={touched.dpoTypeID && errors.dpoTypeID}
                                                            fullWidth
                                                            name="dpoTypeID"
                                                            size='small'
                                                            onChange={(e) => handleChange(e)}
                                                            value={directPurchaseOrderDetails.dpoTypeID}
                                                            variant="outlined"
                                                            disabled={isUpdate || gridDatArray.length > 0}
                                                        >
                                                            <MenuItem value="0">--Select DPO Type--</MenuItem>
                                                            <MenuItem value="1">Order</MenuItem>
                                                            {/* <MenuItem value="2">Request</MenuItem> */}
                                                        </TextField>
                                                    </Grid>
                                                    {isUpdate ?
                                                        <Grid item md={3} xs={12}>
                                                            <InputLabel shrink id="dpoNumber">
                                                                DPO Number
                                                            </InputLabel>
                                                            <TextField
                                                                error={Boolean(touched.dpoNumber && errors.dpoNumber)}
                                                                helperText={touched.dpoNumber && errors.dpoNumber}
                                                                fullWidth
                                                                size='small'
                                                                name="dpoNumber"
                                                                onChange={(e) => handleChange(e)}
                                                                value={dpoNumber}
                                                                variant="outlined"
                                                                disabled={true}
                                                            />
                                                        </Grid> : null}
                                                    {isUpdate ?
                                                        <Grid item md={3} xs={12}>
                                                            <InputLabel shrink id="supplierID">
                                                                Supplier *
                                                            </InputLabel>
                                                            <TextField
                                                                select
                                                                error={Boolean(
                                                                    touched.supplierID && errors.supplierID
                                                                )}
                                                                fullWidth
                                                                helperText={touched.supplierID && errors.supplierID}
                                                                name="supplierID"
                                                                size="small"
                                                                onBlur={handleBlur}
                                                                onChange={e => handleChange(e)}
                                                                value={directPurchaseOrderDetails.supplierID}
                                                                disabled={isUpdate}
                                                                variant="outlined"
                                                                id="supplierID"
                                                            >
                                                                <MenuItem value="0">--Select Supplier--</MenuItem>
                                                                {generateDropDownMenuWithTwoValues(suppliers)}
                                                            </TextField>
                                                        </Grid> :
                                                        <Grid item md={3} xs={12}>
                                                            <InputLabel shrink id="supplierID">
                                                                Supplier *
                                                            </InputLabel>
                                                            <Autocomplete
                                                                id="supplierID"
                                                                options={suppliersAuto}
                                                                getOptionLabel={(option) => option.supplierName != null ? option.supplierName.toString() : null}
                                                                onChange={(e, value) => handleSearchDropdownChangeFieldsSupplier(value, e)}
                                                                defaultValue={null}
                                                                disabled={isUpdate || gridDatArray.length > 0}
                                                                renderInput={(params) =>
                                                                    <TextField {...params}
                                                                        variant="outlined"
                                                                        name="supplierID"
                                                                        fullWidth
                                                                        size='small'
                                                                        placeholder='--Select Supplier--'
                                                                        value={directPurchaseOrderDetails.supplierID}
                                                                        getOptionDisabled={true}
                                                                        helperText={touched.supplierID && errors.supplierID}
                                                                        onBlur={handleBlur}
                                                                        error={Boolean(touched.supplierID && errors.supplierID)}

                                                                    >
                                                                        <MenuItem value={'0'} >--Select Supplier--</MenuItem>
                                                                    </TextField>
                                                                }
                                                            />
                                                        </Grid>}
                                                    {supplierCommon == true ?
                                                        <>
                                                            <Grid item md={3} xs={12}>
                                                                <InputLabel shrink id="supplierName">
                                                                    Supplier Name *
                                                                </InputLabel>
                                                                <TextField
                                                                    error={Boolean(touched.supplierName && errors.supplierName)}
                                                                    helperText={touched.supplierName && errors.supplierName}
                                                                    fullWidth
                                                                    size='small'
                                                                    name="supplierName"
                                                                    onChange={(e) => handleChange(e)}
                                                                    value={directPurchaseOrderDetails.supplierName}
                                                                    disabled={isUpdate || gridDatArray.length > 0}
                                                                    variant="outlined"
                                                                />
                                                            </Grid>
                                                            <Grid item md={3} xs={12}>
                                                                <InputLabel shrink id="supplierContactNo">
                                                                    Supplier Contact No
                                                                </InputLabel>
                                                                <TextField
                                                                    error={Boolean(touched.supplierContactNo && errors.supplierContactNo)}
                                                                    helperText={touched.supplierContactNo && errors.supplierContactNo}
                                                                    fullWidth
                                                                    size='small'
                                                                    name="supplierContactNo"
                                                                    onChange={(e) => handleChange(e)}
                                                                    value={directPurchaseOrderDetails.supplierContactNo}
                                                                    disabled={isUpdate || gridDatArray.length > 0}
                                                                    variant="outlined"
                                                                />
                                                            </Grid></> : null}
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="budgetCodeID">
                                                            Account Code *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.budgetCodeID && errors.budgetCodeID)}
                                                            fullWidth
                                                            helperText={touched.budgetCodeID && errors.budgetCodeID}
                                                            size='small'
                                                            name="budgetCodeID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={directPurchaseOrderDetails.budgetCodeID}
                                                            variant="outlined"
                                                            id="budgetCodeID"
                                                            disabled={isUpdate || gridDatArray.length > 0}
                                                        >
                                                            {generateDropDownMenu(budgetCodes)}
                                                        </TextField>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            <Formik
                                                initialValues={{
                                                    skuCategoryID: directPurchaseOrderDetails.skuCategoryID,
                                                    itemName: directPurchaseOrderDetails.itemName,
                                                    requestAmount: directPurchaseOrderDetails.requestAmount,
                                                    unitPrice: directPurchaseOrderDetails.unitPrice
                                                }}
                                                validationSchema={
                                                    Yup.object().shape({
                                                        skuCategoryID: Yup.number().required('SKU Category is required').min("1", 'SKU Category is required'),
                                                        itemName: Yup.number().required('SKU is required').min("1", 'SKU is required'),
                                                        requestAmount: Yup.number().required('Quantity is required').typeError('Integers Only'),
                                                        unitPrice: Yup.number().when([], {
                                                            is: () => directPurchaseOrderDetails.dpoTypeID == 1 || directPurchaseOrderDetails.dpoTypeID == 0,
                                                            then: Yup.number()
                                                                .required('Unit Price is required')
                                                                .typeError('Integers Only'),
                                                            otherwise: Yup.number().notRequired()
                                                        })
                                                    })
                                                }
                                                enableReinitialize
                                                onSubmit={() => trackPromise(addToGrid())}
                                            >
                                                {({
                                                    errors,
                                                    handleBlur,
                                                    touched,
                                                    values,
                                                }) => (
                                                    <Form>
                                                        <Card style={{ padding: 20 }}>
                                                            <Grid container spacing={3}>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="skuCategoryID">
                                                                        SKU Category *
                                                                    </InputLabel>
                                                                    <TextField select
                                                                        error={Boolean(touched.skuCategoryID && errors.skuCategoryID)}
                                                                        helperText={touched.skuCategoryID && errors.skuCategoryID}
                                                                        fullWidth
                                                                        name="skuCategoryID"
                                                                        size='small'
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={directPurchaseOrderDetails.skuCategoryID}
                                                                        variant="outlined"
                                                                        disabled={decryptedStatusIDD == 3 || decryptedStatusIDD == 4}
                                                                    >
                                                                        <MenuItem value="0">--Select SKU Category--</MenuItem>
                                                                        {generateDropDownMenu(SKUCategoryNames)}
                                                                    </TextField>
                                                                </Grid>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="itemName">
                                                                        SKU *
                                                                    </InputLabel>
                                                                    <Autocomplete
                                                                        options={itemCopy || []}
                                                                        getOptionLabel={(option) => option.skuMasterName ? option.skuMasterName.toString() : ""}
                                                                        value={(itemCopy && itemCopy.find((itemNameName) => itemNameName.skuMasterID === directPurchaseOrderDetails.itemName)) || null}
                                                                        onChange={(event, newValue) => {
                                                                            setDirectPurchaseOrderDetails((prev) => ({
                                                                                ...prev,
                                                                                itemName: newValue ? newValue.skuMasterID : 0
                                                                            }));
                                                                        }}
                                                                        clearOnBlur={false}
                                                                        renderInput={(params) => (<TextField
                                                                            {...params}
                                                                            error={Boolean(touched.itemName && errors.itemName)}
                                                                            fullWidth
                                                                            helperText={touched.itemName && errors.itemName}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            placeholder="--Select SKU --"
                                                                        />)}
                                                                        disabled={decryptedStatusIDD == 3 || decryptedStatusIDD == 4}
                                                                    />
                                                                </Grid>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="availableQuantity">
                                                                        Available Quantity
                                                                    </InputLabel>
                                                                    <TextField
                                                                        error={Boolean(touched.availableQuantity && errors.availableQuantity)}
                                                                        helperText={touched.availableQuantity && errors.availableQuantity}
                                                                        fullWidth
                                                                        size='small'
                                                                        name="availableQuantity"
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={availableQuantity ? (availableQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0'}
                                                                        variant="outlined"
                                                                        InputProps={{
                                                                            readOnly: true,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="measuringUnitName">
                                                                        Measuring Unit
                                                                    </InputLabel>
                                                                    <TextField
                                                                        fullWidth
                                                                        size='small'
                                                                        name="measuringUnitName"
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={measuringUnitName}
                                                                        variant="outlined"
                                                                        disabled={true}
                                                                    />
                                                                </Grid>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="requestAmount">
                                                                        Requested Quantity *
                                                                    </InputLabel>
                                                                    <TextField
                                                                        error={Boolean(touched.requestAmount && errors.requestAmount)}
                                                                        helperText={touched.requestAmount && errors.requestAmount}
                                                                        fullWidth
                                                                        size='small'
                                                                        name="requestAmount"
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                                handleChange(e);
                                                                            }
                                                                        }}
                                                                        value={directPurchaseOrderDetails.requestAmount}
                                                                        variant="outlined"
                                                                        disabled={decryptedStatusIDD == 3 || decryptedStatusIDD == 4}
                                                                    />
                                                                </Grid>
                                                                {directPurchaseOrderDetails.dpoTypeID == 1 || directPurchaseOrderDetails.dpoTypeID == 2 || isUpdate ?
                                                                    <Grid item md={3} xs={12}>
                                                                        <InputLabel shrink id="unitPrice">
                                                                            Unit Price (Rs) *
                                                                        </InputLabel>
                                                                        <TextField
                                                                            error={Boolean(touched.unitPrice && errors.unitPrice)}
                                                                            helperText={touched.unitPrice && errors.unitPrice}
                                                                            fullWidth
                                                                            size='small'
                                                                            name="unitPrice"
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                                    handleChange(e);
                                                                                }
                                                                            }}
                                                                            value={directPurchaseOrderDetails.unitPrice}
                                                                            variant="outlined"
                                                                            disabled={decryptedStatusIDD == 3 || decryptedStatusIDD == 4}
                                                                        />
                                                                    </Grid>
                                                                    : null}
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="remark">
                                                                        Remark
                                                                    </InputLabel>
                                                                    <TextField
                                                                        fullWidth
                                                                        size='small'
                                                                        name="remark"
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={directPurchaseOrderDetails.remark}
                                                                        variant="outlined"
                                                                        disabled={decryptedStatusIDD == 3 || decryptedStatusIDD == 4}
                                                                    />
                                                                </Grid>
                                                                {decryptedStatusIDD == 1 || decryptedStatusIDD == 2 ?
                                                                    <Grid item md={12} xs={12}
                                                                        container
                                                                        direction="row"
                                                                        justify="flex-end"
                                                                        alignItems="center">
                                                                        <Button
                                                                            color="primary"
                                                                            type="submit"
                                                                            variant="contained"
                                                                            size='small'
                                                                        >
                                                                            {isUpdate2 == true ? 'Update' : 'Add'}
                                                                        </Button>
                                                                    </Grid> : null}
                                                                {gridDatArray.length > 0 ? (
                                                                    <Grid item xs={12}>
                                                                        {directPurchaseOrderDetails.dpoTypeID == 1 ?
                                                                            <TableContainer>
                                                                                <Table size='small' aria-label="customized table">
                                                                                    <TableHead>
                                                                                        <TableRow>
                                                                                            <TableCell align="left">SKU Category</TableCell>
                                                                                            <TableCell align="left">SKU</TableCell>
                                                                                            <TableCell align="right">Requested Qty</TableCell>
                                                                                            <TableCell align="right">Mesuring Unit</TableCell>
                                                                                            <TableCell align="right">Unit Price (Rs.)</TableCell>
                                                                                            {/* <TableCell align="right">Item Discount</TableCell> */}
                                                                                            <TableCell align="right">VAT Amount (Rs.)</TableCell>
                                                                                            <TableCell align="right">Total (Rs.)</TableCell>
                                                                                            {!isUpdate2 || !isUpdate || decryptedStatusIDD == 4 && (decryptedStatusIDD == 1 || decryptedStatusIDD == 2) ?
                                                                                                <TableCell align="center">Action</TableCell>
                                                                                                : null}

                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        {gridDatArray.map((row, index) => (
                                                                                            <TableRow key={index}>
                                                                                                <TableCell align="left" style={{ borderBottom: 'none' }}>
                                                                                                    {row.skuCategoryName}
                                                                                                </TableCell>
                                                                                                <TableCell align="left" style={{ borderBottom: 'none' }}>
                                                                                                    {row.skuMasterName}
                                                                                                </TableCell>

                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.requestedQuantity.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                                                </TableCell>

                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.skuMesuringUnit}
                                                                                                </TableCell>
                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.unitPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                                {/* <TableCell align="right" style={{ border: 'none', padding: '8px' }}>
                                                                                                    {decryptedStatusIDD == 1 || decryptedStatusIDD == 2 ?
                                                                                                        <Box display="flex" justifyContent="flex-end">
                                                                                                            <TextField
                                                                                                                size='small'
                                                                                                                onChange={(e) => changeGeneralText(e, index)}
                                                                                                                value={row.discount}
                                                                                                                InputProps={{
                                                                                                                    inputProps: {
                                                                                                                        step: 0.01,
                                                                                                                        type: 'number',
                                                                                                                        style: {
                                                                                                                            textAlign: 'right',
                                                                                                                            width: '100px'
                                                                                                                        },
                                                                                                                    },
                                                                                                                }}
                                                                                                                onKeyDown={(evt) =>
                                                                                                                    (evt.key === "-") && evt.preventDefault()
                                                                                                                }
                                                                                                                onWheel={event => event.target.blur()}
                                                                                                                variant="outlined"
                                                                                                            />
                                                                                                        </Box> :
                                                                                                        <Box textAlign="right">{row.discount}</Box>
                                                                                                    }
                                                                                                </TableCell> */}
                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.vatAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.total.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                                <TableCell align="center" style={{ borderBottom: 'none' }}>
                                                                                                    {!isUpdate2 && (decryptedStatusIDD == 1 || decryptedStatusIDD == 2) ?
                                                                                                        <>
                                                                                                            <EditIcon
                                                                                                                style={{
                                                                                                                    color: "black",
                                                                                                                    marginBottom: "1rem",
                                                                                                                    marginTop: "1rem",
                                                                                                                    cursor: "pointer"
                                                                                                                }}
                                                                                                                size="small"
                                                                                                                onClick={() => handleClickEditTheRow(row, index)}
                                                                                                            >
                                                                                                            </EditIcon>
                                                                                                            <DeleteIcon
                                                                                                                style={{
                                                                                                                    color: "red",
                                                                                                                    marginBottom: "1rem",
                                                                                                                    marginTop: "1rem",
                                                                                                                    cursor: "pointer"
                                                                                                                }}
                                                                                                                size="small"
                                                                                                                onClick={() => DeleteItem(row, index)}
                                                                                                            >
                                                                                                            </DeleteIcon></> : null}
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        ))}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                            :
                                                                            <TableContainer>
                                                                                <Table size='small' aria-label="customized table">
                                                                                    <TableHead>
                                                                                        <TableRow>
                                                                                            <TableCell align="left">SKU Category</TableCell>
                                                                                            <TableCell align="left">SKU</TableCell>
                                                                                            <TableCell align="right">Requested Qty</TableCell>
                                                                                            <TableCell align="right">Mesuring Unit</TableCell>
                                                                                            <TableCell align="right">Unit Price (Rs)</TableCell>
                                                                                            <TableCell align="right">VAT Amount</TableCell>
                                                                                            <TableCell align="right">Total</TableCell>
                                                                                            {!isUpdate2 && (decryptedStatusIDD == 1 || decryptedStatusIDD == 2) ?
                                                                                                <TableCell align="center">Action</TableCell>
                                                                                                : null}
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        {gridDatArray.map((row, index) => (
                                                                                            <TableRow key={index}>
                                                                                                <TableCell align="left" style={{ borderBottom: 'none' }}>
                                                                                                    {row.skuCategoryName}
                                                                                                </TableCell>
                                                                                                <TableCell align="left" style={{ borderBottom: 'none' }}>
                                                                                                    {row.skuMasterName}
                                                                                                </TableCell>
                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.requestedQuantity.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.skuMesuringUnit}
                                                                                                </TableCell>
                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.unitPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.vatAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                                <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                    {row.total.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                                                </TableCell>
                                                                                                <TableCell align="center" style={{ borderBottom: 'none' }}>
                                                                                                    {!isUpdate2 && (decryptedStatusIDD == 1 || decryptedStatusIDD == 2) ?
                                                                                                        <>
                                                                                                            <EditIcon
                                                                                                                style={{
                                                                                                                    color: "black",
                                                                                                                    marginBottom: "1rem",
                                                                                                                    marginTop: "1rem",
                                                                                                                    cursor: "pointer"
                                                                                                                }}
                                                                                                                size="small"
                                                                                                                onClick={() => handleClickEditTheRow(row, index)}
                                                                                                            >
                                                                                                            </EditIcon>
                                                                                                            <DeleteIcon
                                                                                                                style={{
                                                                                                                    color: "red",
                                                                                                                    marginBottom: "1rem",
                                                                                                                    marginTop: "1rem",
                                                                                                                    cursor: "pointer"
                                                                                                                }}
                                                                                                                size="small"
                                                                                                                onClick={() => DeleteItem(row, index)}
                                                                                                            >
                                                                                                            </DeleteIcon></> : null}
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        ))}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </TableContainer>
                                                                        }
                                                                    </Grid>
                                                                ) : null}
                                                                {dialogbox ? <AlertDialogWithoutButton confirmData={confirmData} cancelData={cancelData}
                                                                    IconTitle={"Delete"}
                                                                    headerMessage={"Are you sure you want to delete?"}
                                                                /> : null}
                                                            </Grid>
                                                        </Card>
                                                    </Form>)
                                                }
                                            </Formik>
                                            <CardContent>
                                                {gridDatArray.length > 0 ?
                                                    <Grid container spacing={3}>
                                                        <Grid item md={8} xs={12}></Grid>
                                                        {directPurchaseOrderDetails.dpoTypeID == 1 ?
                                                            <Grid item md={4} xs={12}
                                                                container
                                                                direction="row"
                                                                justify="flex-end"
                                                                alignItems="center">
                                                                <Card style={{ border: "1px solid black" }}>
                                                                    <Grid container spacing={1}>
                                                                        <Grid item md={12} xs={12} style={{ marginTop: '10px', marginLeft: '15px', marginRight: '5px' }}>
                                                                            <Typography variant="h4">Total Invoice Amount</Typography>
                                                                        </Grid>
                                                                        <Grid item md={5} xs={12} style={{ marginLeft: '15px' }}>
                                                                            <Typography variant="h5">Total Payable</Typography>
                                                                        </Grid>
                                                                        <Grid item md={1} xs={12}>
                                                                            <Typography variant="h5">:</Typography>
                                                                        </Grid>
                                                                        <Grid item md={5} xs={12} style={{ textAlign: 'right' }}>
                                                                            <Typography variant="h5">
                                                                                {gridDatArray.reduce((accumulator, current) => accumulator + (current.requestedQuantity * current.unitPrice), 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                            </Typography>
                                                                        </Grid>
                                                                        {/* <Grid item md={5} xs={12} style={{ marginLeft: '15px' }}>
                                                                            <Typography variant="h5">Discount</Typography>
                                                                        </Grid> */}
                                                                        {/* <Grid item md={1} xs={12}>
                                                                            <Typography variant="h5">:</Typography>
                                                                        </Grid>
                                                                        <Grid item md={5} xs={12} style={{ textAlign: 'right' }}>
                                                                            <Typography variant="h5">
                                                                                {gridDatArray.reduce((accumulator, current) => accumulator + current.discount, 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                            </Typography>
                                                                        </Grid> */}
                                                                        <Grid item md={5} xs={12} style={{ marginLeft: '15px' }}>
                                                                            <Typography variant="h5">Value Added Tax (VAT)</Typography>
                                                                        </Grid>
                                                                        <Grid item md={1} xs={12}>
                                                                            <Typography variant="h5" >:</Typography>
                                                                        </Grid>
                                                                        <Grid item md={5} xs={12} style={{ textAlign: 'right' }}>
                                                                            <Typography variant="h5">
                                                                                {gridDatArray.reduce((accumulator, current) => accumulator + current.vatAmount, 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item md={5} xs={12} style={{ marginLeft: '15px', marginBottom: '15px' }}>
                                                                            <Typography variant="h5">Net Amount Payable</Typography>
                                                                        </Grid>
                                                                        <Grid item md={1} xs={12}>
                                                                            <Typography variant="h5">:</Typography>
                                                                        </Grid>
                                                                        <Grid item md={5} xs={12} style={{ textAlign: 'right' }}>
                                                                            <Typography variant="h5">
                                                                                {gridDatArray.reduce((accumulator, current) => accumulator + current.total, 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Card>
                                                            </Grid>
                                                            : null}
                                                        {isUpdate2 == false ?
                                                            <Grid item md={12} xs={12}
                                                                container
                                                                direction="row"
                                                                justify="flex-end"
                                                                alignItems="center">
                                                                {gridDatArray.length > 0 && (decryptedStatusIDD == 1 || decryptedStatusIDD == 2) ?
                                                                    <Button
                                                                        color="primary"
                                                                        type="submit"
                                                                        variant="contained"
                                                                        size='small'
                                                                    >
                                                                        {isUpdate == true ? 'Update' : 'Save'}
                                                                    </Button> : null}
                                                                {decryptedStatusIDD == 4 ?
                                                                    <Button
                                                                        color="red"
                                                                        type="button"
                                                                        variant="contained"
                                                                        size='small'
                                                                        style={{
                                                                            backgroundColor: "red",
                                                                            color: "white"
                                                                        }}
                                                                        onClick={() => handleReject()}
                                                                    >
                                                                        Reject
                                                                    </Button> : null}
                                                                &nbsp;
                                                                {decryptedStatusIDD == 4 ?
                                                                    <Button
                                                                        color="green"
                                                                        type="button"
                                                                        variant="contained"
                                                                        size='small'
                                                                        style={{
                                                                            backgroundColor: "green",
                                                                            color: "white"
                                                                        }}
                                                                        onClick={() => handleApprove()}
                                                                    >
                                                                        Approve
                                                                    </Button> : null}
                                                            </Grid>
                                                            : null}
                                                    </Grid>
                                                    : null}
                                            </CardContent>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                    {dialogboxOne ? <AlertDialogWithoutButton confirmData={confirmDataOne} cancelData={cancelDataOne}
                        IconTitle={"Approve"}
                        headerMessage={"Are you sure you want to approve ?"}
                    /> : null}
                    {dialogboxTwo ? <AlertDialogWithoutButton confirmData={confirmDataTwo} cancelData={cancelDataTwo}
                        IconTitle={"Reject"}
                        headerMessage={"Are you sure you want to reject ?"}
                    /> : null}
                </Container>
            </Page >
        </Fragment>
    )
}
